import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { useJourney } from "@/contexts/JourneyContext";
import JourneyHeader from "@/components/JourneyHeader";

const LenderRejectedExploreMore = () => {
    const navigate = useNavigate();
    const { logEvent } = useJourney();
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    logEvent({
                        stage: 'ALL_OFFERS',
                        advance: true,
                        allow_rewind: true
                    }).then(() => {
                        navigate('/all-offers');
                    });
                    return 0;
                }
                return prev - 1;
            });
        }, 3000);

        return () => clearInterval(timer);
    }, [navigate, logEvent]);

    return (
        <div className="min-h-screen bg-intellend-white flex flex-col">
            <JourneyHeader />

            <main className="px-3 py-3 flex-1 flex flex-col justify-center max-w-md mx-auto w-full">
                <div className="bg-white shadow-md rounded-lg p-6 text-center animate-in fade-in zoom-in duration-500">
                    <div className="bg-red-50 border border-red-100 rounded-xl p-6 mb-6">
                        <h2 className="text-xl font-bold text-red-600 mb-2">Offer Not Approved</h2>
                        <p className="text-gray-700">
                            Unfortunately, the lender was unable to approve the requested loan terms at this time.
                        </p>
                    </div>

                    <p className="text-gray-600 mb-8 leading-relaxed">
                        Don't worry! We have several other lenders who might be a better match for your requirements.
                    </p>

                    <div className="bg-blue-50 rounded-lg p-4 mb-8">
                        <p className="text-sm font-medium text-intellend-green">
                            Redirecting to explore more offers in <span className="text-lg font-bold">{countdown}</span> seconds...
                        </p>
                    </div>

                    <div className="flex flex-col gap-3">
                        <Button
                            className="w-full bg-intellend-green hover:bg-intellend-green/90 h-12 text-lg font-semibold"
                            onClick={() => navigate('/all-offers')}
                        >
                            Explore More Now
                        </Button>
                        <Button
                            variant="ghost"
                            className="w-full text-gray-500"
                            onClick={() => navigate('/')}
                        >
                            Exit to Home
                        </Button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default LenderRejectedExploreMore;
